/**
 * Окошко правки текста комментария — поле ввода прямо в рамке выноски на чертеже.
 *
 * Как в Ремпланнере: кликнул по плану — появилось окошко, пишешь сразу. Поле лежит поверх
 * холста ровно в рамке выноски и того же кегля, рамка растёт вместе с текстом.
 * Enter или клик мимо — готово, Shift+Enter — новая строка, Esc — тоже готово.
 * Что делать с пустым комментарием, решает тот, кто закрывает окошко.
 */
import { UIKit } from "@/shared/ui";
import type { PlanComment } from "@/shared/plan";
import { COMMENT_LINE_HEIGHT, commentBox, planToCanvasPx } from "../logic";

interface Props {
	comment: PlanComment;
	/** Левый верхний угол видимой части плана, мм */
	viewBox: { x: number; y: number };
	mmPerPx: number;
	onChange: (text: string) => void;
	onFinish: () => void;
}

export const CommentEditor = ({ comment, viewBox, mmPerPx, onChange, onFinish }: Props) => {
	const box = commentBox(comment, mmPerPx);
	const at = planToCanvasPx({ x: box.x, y: box.y }, viewBox, mmPerPx);
	return (
		<UIKit.Textarea
			bare
			autoFocus
			aria-label="Текст комментария"
			placeholder="Текст…"
			className="absolute z-10 resize-none overflow-hidden border-0 bg-transparent outline-none placeholder:text-ink/60"
			style={{
				left: at.x,
				top: at.y,
				width: box.width / mmPerPx,
				height: box.height / mmPerPx,
				padding: `${(box.padding * 0.7) / mmPerPx}px ${box.padding / mmPerPx}px 0`,
				fontSize: comment.fontSize,
				lineHeight: COMMENT_LINE_HEIGHT,
				color: comment.color,
			}}
			value={comment.text}
			onChange={onChange}
			onBlur={onFinish}
			onKeyDown={(e) => {
				if ((e.key === "Enter" && !e.shiftKey) || e.key === "Escape") {
					e.preventDefault();
					onFinish();
				}
			}}
		/>
	);
};
